import { useToast, Text, Heading, Stack } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { useParams } from 'react-router';

import AppCard from 'components/UI/AppCard';
import { ExportFile } from 'hooks/data/datasets/types';
import useDownloadFile from 'hooks/data/files/useDownloadFiles';
import useDownloadSpoldFile from 'hooks/data/files/useDownloadSpoldFile';
import { useDatasetSession } from 'pages/Dataset/DatasetSessionContext';
import DownloadFileContent from 'pages/Export/components/DownloadFileContent';
import LoadingToast from 'pages/Files/LoadingToast';
import { incrementExportOrDownload } from 'utilities/consent/cookies';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

type Props = { isLoading?: boolean };

const Export = ({ isLoading }: Props) => {
  const { mutateAsync: downloadSpoldFile } = useDownloadSpoldFile();
  const { mutateAsync: downloadFile } = useDownloadFile();
  const { spold_id } = useParams();
  const toast = useToast();
  const { increment } = useDatasetSession();

  const onDownload = async (file: ExportFile) => {
    mixpanel.track(MIXPANEL_EVENTS.EXPORT_DATASET, { file: file.name, spold_id });
    increment('export_dataset_count');
    incrementExportOrDownload();
    const toastRef = toast({
      description: 'Your file download is being prepared, please wait...',
      duration: 9000,
      isClosable: true,
      render: LoadingToast,
    });

    file.is_s3_presigned ? await downloadFile(file.url) : await downloadSpoldFile(file.url);

    toast.close(toastRef);
  };

  return (
    <AppCard>
      <Stack>
        <Heading as="h4" size="md">
          Export Dataset
        </Heading>
        <Text>Here you can download the content of a dataset, in various different formats.</Text>
      </Stack>
      <DownloadFileContent onDownload={onDownload} isLoading={isLoading} />
    </AppCard>
  );
};
export default Export;
